import { render, staticRenderFns } from "./TagFormPage.vue?vue&type=template&id=3e3fa57e"
import script from "./TagFormPage.vue?vue&type=script&lang=js"
export * from "./TagFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports